<script setup>
import { onMounted } from "vue";
import Header from "@/components/Header.vue";

// Landing is dark-only while we're still iterating on the visual treatment.
// The ThemeToggle is hidden from the landing header (see Header.vue); we
// force the `dark` class on mount so first-time visitors and anyone who
// previously toggled to light in the authenticated app both see the
// landing in dark mode. Authenticated views still respect localStorage.
onMounted(() => {
  document.documentElement.classList.add("dark");
});
import HeroSection from "@/components/landing/HeroSection.vue";
import ROIStatsBlock from "@/components/landing/ROIStatsBlock.vue";
import PressBar from "@/components/landing/PressBar.vue";
import SocialProofStrip from "@/components/landing/SocialProofStrip.vue";
import PrivacyTrust from "@/components/landing/PrivacyTrust.vue";
import ProductTabs from "@/components/landing/ProductTabs.vue";
import HowItWorks from "@/components/landing/HowItWorks.vue";
import FeatureDeepDive from "@/components/landing/FeatureDeepDive.vue";
import AlertsStickyShowcase from "@/components/landing/AlertsStickyShowcase.vue";
import UseCasesSection from "@/components/landing/UseCasesSection.vue";
import PlatformsSection from "@/components/landing/PlatformsSection.vue";
import TestimonialWall from "@/components/landing/TestimonialWall.vue";
import PricingSection from "@/components/landing/PricingSection.vue";
import FAQGrouped from "@/components/landing/FAQGrouped.vue";
import FinalCTA from "@/components/landing/FinalCTA.vue";
import ContactSection from "@/components/ContactSection.vue";
import Footer from "@/components/landing/Footer.vue";
import MobileStickyCTA from "@/components/landing/MobileStickyCTA.vue";
</script>

<template>
  <main class="min-h-screen bg-background overflow-x-hidden">
    <Header />
    <HeroSection />
    <ROIStatsBlock />
    <!-- Press / authority bar between ROI numbers and customer logos —
         credibility stack: stats → external authority → customers. -->
    <PressBar />
    <SocialProofStrip />
    <!-- PrivacyTrust moved up: preempts the ethical objection right after
         the visitor sees the numbers and logos, before showing product. -->
    <PrivacyTrust />
    <!-- Major transition: from "trust building" to "product depth".
         Visual dot divider marks the chapter break. -->
    <div class="container mx-auto px-6"><div class="section-divider-dot max-w-3xl mx-auto" /></div>
    <ProductTabs />
    <HowItWorks />
    <FeatureDeepDive />
    <!-- Sticky-scroll showcase for the 7 alert types — most visually
         impactful section, mirrors Hubstaff's pattern. -->
    <AlertsStickyShowcase />
    <!-- Temporarily hidden while we iterate on the rest of the page.
         Components and i18n keys kept intact so we can re-enable by
         uncommenting these two lines. -->
    <!-- <UseCasesSection /> -->
    <!-- <PlatformsSection /> -->
    <!-- TestimonialWall placed just before pricing: real customers reinforce
         the buying decision at the moment of financial commitment. -->
    <TestimonialWall />
    <!-- Chapter break before the financial decision -->
    <div class="container mx-auto px-6"><div class="section-divider-dot max-w-3xl mx-auto" /></div>
    <PricingSection />
    <FAQGrouped />
    <FinalCTA />
    <ContactSection />
    <Footer />
    <!-- Mobile-only sticky CTA bar; appears after first viewport scroll. -->
    <MobileStickyCTA />
  </main>
</template>
